import IFaultObj from 'data/abitilies/interfaces/IFaultObj'
import GameType, {
  gamesInCurrentTalentMap,
  gamesInTypes
} from '../data/games/gameTypes'
import { getCurrentAssessment } from './patient'

export const getGameImage = (type: GameType) => {
  switch (type) {
    case GameType.math:
      return require('../assets/img/games/math.svg')
    case GameType.attention:
      return require('../assets/img/games/attention.svg')
    case GameType.memory:
      return require('../assets/img/games/memory.svg')
    case GameType.spatial:
      return require('../assets/img/games/spatial.svg')
    case GameType.executiveFunctions:
      return require('../assets/img/games/executiveFunctions.svg')
    default:
      return ''
  }
}

export const getGameTitle = (type: GameType): string => {
  switch (type) {
    case GameType.math:
      return 'Math'
    case GameType.attention:
      return 'Attention'
    case GameType.memory:
      return 'Memory'
    case GameType.spatial:
      return 'Spatial'
    case GameType.executiveFunctions:
      return 'Flexible Thinking'
    default:
      return ''
  }
}

export const getGameInfo = (
  currentPatient: any,
  type: GameType
): { completed: number; fullCount: number; isGame: boolean } | null => {
  switch (type) {
    case GameType.attention:
    case GameType.math:
    case GameType.memory:
    case GameType.spatial:
      return getBaseGameInfo(currentPatient, type)
    case GameType.executiveFunctions:
      return getBaseGameInfo(currentPatient, type, [
        { key: GameType.attention, games: { sart: ['sart_reverse'] } },
        {
          key: GameType.memory,
          games: { corsi_blocks_reverse: ['corsi_blocks_reverse'] }
        }
      ])
    default:
      return null
  }
}

const getBaseGameInfo = (
  currentPatient: any,
  type: GameType,
  keys?: Array<{
    key: string
    games: { [gameName: string]: string[] }
  }>
) => {
  const isGame = !keys

  if (!keys) {
    keys = [{ key: type, games: gamesInTypes[type] }]
  }

  const assessment = getCurrentAssessment(currentPatient)
  if (!assessment) {
    return null
  }

  const result = {
    completed: 0,
    fullCount: keys.reduce((acc, v) => acc + Object.keys(v.games).length, 0),
    isGame
  }
  const currentTalentMap = assessment.current_talent_map
  keys.forEach(game =>
    Object.keys(game.games).forEach(
      k =>
        game.games[k].every(gameKey => {
          const gameinTalentMap =
            gamesInCurrentTalentMap[game.key][gameKey] || null
          return (
            gameinTalentMap &&
            currentTalentMap &&
            currentTalentMap[gameinTalentMap] > -1
          )
        }) && ++result.completed
    )
  )

  return result
}

export const getFaultGames = (faultObj?: IFaultObj) => {
  if (!faultObj) {
    return []
  }

  const faultGameNames: string[] = Object.keys(faultObj).filter(
    key => faultObj[key]
  )

  const faultGames = faultGameNames.reduce((acc, gameName) => {
    for (const game in gamesInTypes) {
      if (gamesInTypes.hasOwnProperty(game)) {
        for (const gameN in gamesInTypes[game]) {
          if (gamesInTypes[game].hasOwnProperty(gameN)) {
            const element = gamesInTypes[game][gameN]
            if (element.includes(gameName)) {
              return { ...acc, [game]: true }
            }
          }
        }
      }
    }
    return acc
  }, {}) as { [key: string]: boolean }

  return Object.keys(faultGames).filter(key => faultGames[key]) as GameType[]
}

export const getGamesCount = (patientDetail: any): number => {
  const count = 0

  const assessment = getCurrentAssessment(patientDetail)

  if (!assessment) {
    return count
  }
  const currentTalentMap = assessment.current_talent_map
  return Object.entries(gamesInTypes).reduce((currCount, [key, value]) => {
    const countForCurrentKey = Object.keys(value).reduce((acc, gameKey) => {
      const gameinTalentMap = gamesInCurrentTalentMap[key][gameKey] || null
      const haveScores: boolean =
        !!gameinTalentMap &&
        !!currentTalentMap &&
        currentTalentMap[gameinTalentMap] > -1

      return haveScores ? acc : acc + 1
    }, 0)

    return currCount + countForCurrentKey
  }, count)
}

export default {
  getGameImage,
  getGameTitle,
  getGameInfo,
  getFaultGames,
  getGamesCount
}



// WEBPACK FOOTER //
// ./src/services/games.ts